import {COLORS, FONT_SIZES, FONT_WEIGHTS, Text} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const CouponStreamHeadline: FC<{
  headline: string;
  count: number;
  darkMode?: boolean;
  className?: string;
}> = ({className, count, headline, darkMode = false}) => {
  return (
    <Headline
      className={className}
      data-testid="headline"
      size="px16"
      weight="mediumHeavy"
      data-dark-mode={darkMode}
    >
      {headline}
      <Count data-dark-mode={darkMode}>{count}</Count>
    </Headline>
  );
};

const Headline = styled(Text)`
  line-height: 1.25;
  display: flex;
  gap: 6px;
  padding-inline: 2px;

  &[data-dark-mode='true'] {
    color: ${COLORS.White};
  }
`;

const Count = styled.span`
  color: ${COLORS.White};
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.6;
  border-radius: 50px;
  background-color: ${COLORS.PrimaryCoupon};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 8px;

  &[data-dark-mode='true'] {
    background-color: ${COLORS.White};
    color: ${COLORS.PrimaryCoupon};
  }
`;
